import React from "react";

// pages
import Feature1 from "./components/Feature1";

export default function Home() {
  return (
    <div>
      <Feature1 />
    </div>
  );
}
